import styled from 'styled-components';

export const ShowMenuItem = styled.div`
  display: none;

  @media (max-width: 840px) {
    display: block;
  }
`;

export const HideMenuItem = styled.div`
  display: block;

  @media (max-width: 840px) {
    display: none;
  }
`;

export const LogoWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;

  @media (min-width: 841px) {
    justify-content: flex-start;
  }
`;

export const UserName = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;

  p {
    font-size: 16px;
    color: ${({ theme }) => theme.colors.text};
    max-width: 200px;
    overflow: hidden;
    text-align: center;
  }
`;

export const DrawerContainer = styled.div`
  width: 20rem;
`;

export const FlexRow = styled.div`
  display: flex;
  align-items: center;
  margin-right: 6rem;
  gap: 2rem;
  width: 100%;
`;

export const PopupRight = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  min-width: auto;
  max-width: fit-content;

  z-index: 1;
`;
